module.exports = __webpack_public_path__ + "public/img/Square_combinationmark_black.86f47e40.png";